var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var CreditCard = function CreditCard(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H4V8Zm-2 2V8a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4v-6Zm18 1v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-5h16ZM6 15a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1Zm5-1a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default CreditCard;